<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-07-27 17:17:45
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalType\newApprovalType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_approvalType_form_newTitle')"
    widthClass="max-1000"
    :initData="approvalTypeData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'flow_type_name',
      'color_code',
      'flow_type_description',
      'flow_icon',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="approvalTypeData.flow_type_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  approvalTypeData.flow_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_approvalType_form_approvalTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_approvalType_form_tagColorLabel")
            }}</v-sheet>
            <SelectColor
              :items="$Colors"
              v-model="approvalTypeData.color_code"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="approvalTypeData.flow_type_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  approvalTypeData.flow_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_approvalType_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_approvalType_form_flowIconLabel")
            }}</v-sheet>
            <ImgDragUpdate
              @change="(img) => (approvalTypeData.flow_icon = img)"
              single
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_approvalType_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="approvalTypeData.remarks"
              dense
              counter="500"
              single-line
              filled
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toNew" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newApprovalType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: false,
      isChanged: false,
      approvalTypeData: {
        flow_type_name: "",
        color_code: "",
        flow_type_description: "",
        flow_icon: null,
        remarks: "",
      },
    };
  },

  mounted() {
    // this.approvalTypeData.flow_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.approvalTypeData.flow_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
  },
  methods: {
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }

      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/add-approval-type-table/",
        data: {
          flow_type_name: this.$transCommonLangKey(
            this.approvalTypeData.flow_type_name
          ),
          color_code: this.approvalTypeData.color_code,
          flow_type_description: this.$transCommonLangKey(
            this.approvalTypeData.flow_type_description
          ),
          attachment_uuid: this.approvalTypeData.flow_icon
            ? this.approvalTypeData.flow_icon["uuid"]
            : "", //2020-11.2 BJ flow_ico->attachment_uuid
          remarks: this.approvalTypeData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
